<template>
  <div>
    <v-row class="ma-0 pa-3 align-center">

      <v-col cols="12">
        <v-text-field
          label="Número da linha"
          v-model="obj.phoneNumber"
          hide-details/>
      </v-col>

      <v-col cols="10">
        <v-select v-model="obj.operator"
          label="Operadora"
          :items="allOperators"
          hide-details/>
      </v-col>
      <v-col cols="2 text-right">
        <v-btn icon
          :loading="isDetecting"
          @click.stop="detectOperator">
          <v-icon>mdi-lightbulb-on-outline</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="6">
        <v-switch v-model="obj.isApn"
          label="Cartão com APN"
          single-line hide-details/>
      </v-col>

      <v-col cols="6">
        <v-switch v-model="obj.isPrePaid"
          class="right-switch"
          label="Cartão pré-pago"
          single-line hide-details/>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="obj.comments"
          label="Comentários"
          hide-details/>
      </v-col>

    </v-row>
    <v-card-actions class="pa-6">
      <v-btn text large
        @click="$emit('dismiss')">Cancelar</v-btn>
      <v-spacer/>
      <v-btn text large color="primary"
        @click="$emit('save', obj)">Salvar</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import _ from 'lodash'
import {SimCard} from '@/models'

export default {
  props: {
    value: {},
    allOperators: {type: Array},
  },
  data() {
    return {
      isDetecting: false,
      obj: _.cloneDeep(this.value)
    }
  },
  watch: {
    value(newVal) {
      this.obj = _.cloneDeep(newVal)
    }
  },
  methods: {
    async detectOperator() {
      this.isDetecting = true
      let res = await SimCard.detectOperator(this.obj.iccid)
      this.obj.operator = res.operator
      this.isDetecting = false
    }
  }
}
</script>

<style>
.right-switch {
  flex-flow: row-reverse;
}
</style>
